import { SelectOption } from '@fleet-beat/core';

export enum ServiceRequestStatusEnum {
  NEW = 'new',
  DIAGNOSING = 'diagnosing',
  AWAITING_APPROVAL = 'awaiting_approval',
  SENT = 'sent',
  PROVIDER_ASSIGNED = 'provider_assigned',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  CANCELLED = 'cancelled',
}

export const ServiceRequestStatusOptions: SelectOption[] = [
  { value: ServiceRequestStatusEnum.NEW, label: 'New' },
  { value: ServiceRequestStatusEnum.DIAGNOSING, label: 'Diagnosing' },
  { value: ServiceRequestStatusEnum.AWAITING_APPROVAL, label: 'Awaiting Approval' },
  { value: ServiceRequestStatusEnum.SENT, label: 'Sent to Providers' },
  { value: ServiceRequestStatusEnum.PROVIDER_ASSIGNED, label: 'Provider Assigned' },
  { value: ServiceRequestStatusEnum.IN_PROGRESS, label: 'In Progress' },
  { value: ServiceRequestStatusEnum.RESOLVED, label: 'Resolved' },
  { value: ServiceRequestStatusEnum.CANCELLED, label: 'Cancelled' },
];

export enum ServiceRequestPriorityEnum {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export const ServiceRequestPriorityOptions: SelectOption[] = [
  { value: ServiceRequestPriorityEnum.LOW, label: 'Low' },
  { value: ServiceRequestPriorityEnum.MEDIUM, label: 'Medium' },
  { value: ServiceRequestPriorityEnum.HIGH, label: 'High' },
  { value: ServiceRequestPriorityEnum.CRITICAL, label: 'Critical' },
];

export enum AssistanceTypeEnum {
  MOBILE_MECHANIC = 'mobile_mechanic',
  SHOP_VISIT = 'shop_visit',
  TOWING = 'towing',
}

export const AssistanceTypeOptions: SelectOption[] = [
  { value: AssistanceTypeEnum.MOBILE_MECHANIC, label: 'Mobile Mechanic' },
  { value: AssistanceTypeEnum.SHOP_VISIT, label: 'Shop Visit' },
  { value: AssistanceTypeEnum.TOWING, label: 'Towing' },
];

export enum ServiceProviderStatusEnum {
  SUGGESTED = 'suggested',
  CONTACTED = 'contacted',
  RESPONDED = 'responded',
  DECLINED = 'declined',
  SELECTED = 'selected',
}

export const ServiceProviderStatusOptions: SelectOption[] = [
  { value: ServiceProviderStatusEnum.SUGGESTED, label: 'Suggested' },
  { value: ServiceProviderStatusEnum.CONTACTED, label: 'Contacted' },
  { value: ServiceProviderStatusEnum.RESPONDED, label: 'Responded' },
  { value: ServiceProviderStatusEnum.DECLINED, label: 'Declined' },
  { value: ServiceProviderStatusEnum.SELECTED, label: 'Selected' },
];

export enum ConversationAuthorEnum {
  DRIVER = 'driver',
  AI_ASSISTANT = 'ai_assistant',
  OPERATOR = 'operator',
}

export enum IssueReportChannelEnum {
  VOICE = 'voice',
  TEXT = 'text',
  PHOTO = 'photo',
}

export enum GuidedCheckStatusEnum {
  PENDING = 'pending',
  OK = 'ok',
  ISSUE_PERSISTS = 'issue_persists',
  SKIPPED = 'skipped',
}

export const GuidedCheckStatusOptions: SelectOption[] = [
  { value: GuidedCheckStatusEnum.PENDING, label: 'Pending' },
  { value: GuidedCheckStatusEnum.OK, label: 'OK' },
  { value: GuidedCheckStatusEnum.ISSUE_PERSISTS, label: 'Issue persists' },
  { value: GuidedCheckStatusEnum.SKIPPED, label: 'Skipped' },
];

export enum DiagnosticCodeStateEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
